import React, { useEffect, useState, Fragment } from 'react'
import SezioneBoxed from './SezioneBoxed'

import { Button, Form, Label, Dropdown, Image, Modal, Header, Icon} from 'semantic-ui-react'
import { useForm } from "react-hook-form"

import { useHistory } from "react-router-dom";
import { HashLink as Link } from 'react-router-hash-link';

import { useSnackbar } from 'notistack';
import { allergeni } from './Allergeni';

import imageCompression from 'browser-image-compression';

const DuplicaArticolo = (props) => {

    const { enqueueSnackbar } = useSnackbar();
    const { register, handleSubmit, setValue, watch } = useForm();

    const [saving, setSaving] = useState(false);
    const [openModaleImmagine, setOpenModaleImmagine] = useState(false);
    const [arrayOpzioniCategorie, setArrayOpzioniCategorie] = useState([]);
    const [arrayOpzioniComponentiArticoli, setArrayOpzioniComponentiArticoli] = useState([]);
    const [unitaMisuraDisabilitato, setUnitaMisuraDisabilitato] = useState(false);

    const [compressedImageInfo, setCompressedImageInfo] = useState('');
    const [previewUrl, setPreviewUrl] = useState(null);
    const [compressedImage, setCompressedImage] = useState(null);
    const [flagImmagineModificata, setFlagImmagineModificata] = useState(false);

    // campi da watchare
    const tipologia = watch('tipologia_articolo', 'semplice');
    const idCategoriaArticolo = watch('id_categoria_articolo', '');
    const arrayAllergeni = watch('allergeni_articolo', []);
    const arrayOpzioniComponentiArticolo = watch('componenti_articolo', []);

    let history = useHistory();

    useEffect(() => {
        register({ name: "tipologia_articolo" });
        register({ name: "id_categoria_articolo" });
        register({ name: "allergeni_articolo" });
        register({ name: "componenti_articolo" });
    }, [register]);

    useEffect(() => {

        //All'apertura della pagina torna in cima
        window.scrollTo(0,0);
        
        if (localStorage.getItem('infoUtente') === null) {
            localStorage.removeItem('infoUtente');
            history.push("/login/");
        } else {
            fetch('https://ordinasicuro.it/670914_920408/lib/index.php/api/modifica_articolo/' + props.match.params.id_articolo)
                .then(response => response.json())
                .then(json => {
                    if (json.get_articolo.id_negozio === JSON.parse(localStorage.getItem('infoUtente')).id_negozio) {

                        // preload valori
                        setValue("nome_articolo", json.get_articolo.nome.replace("\\'", "'"));
                        setValue("descrizione_articolo", json.get_articolo.descrizione.replace("\\'", "'"));
                        setValue("id_categoria_articolo", json.get_articolo.id_categoria_articolo);
                        setValue("numero_max_componenti_articolo", json.get_articolo.numero_max_componenti);
                        setValue("unita_misura_articolo", json.get_articolo.unita_misura.replace("\\'", "'"));
                        setValue("prezzo_articolo", json.get_articolo.prezzo);
                        setValue("tipologia_articolo", json.get_articolo.tipologia);

                        if (json.get_articolo.tipologia === 'composto') {
                            setUnitaMisuraDisabilitato(true);
                        }

                        let arrayTemporaneo = [];
                        json.get_categorie_negozio.map(categoria => arrayTemporaneo.push({ key: categoria.id, text: categoria.nome, value: categoria.id }));
                        setArrayOpzioniCategorie(arrayTemporaneo);

                        arrayTemporaneo = [];
                        if (json.get_componenti_articoli) {
                            json.get_componenti_articoli.map(componente => arrayTemporaneo.push({ key: componente.id, text: componente.nome, value: componente.id }));
                            setArrayOpzioniComponentiArticoli(arrayTemporaneo); 
                        }
                        

                        if (json.get_articolo.tipologia === 'composto') {
                            arrayTemporaneo = [];
                            json.get_componenti_articolo.map(componente => { if (componente !== null) { arrayTemporaneo.push(componente.id) } });
                            setValue("componenti_articolo", arrayTemporaneo);
                        }

                        if (json.get_articolo.allergeni) {
                            try {
                                const allergeniParsed = JSON.parse(json.get_articolo.allergeni);
                                setValue("allergeni_articolo", allergeniParsed);
                            } catch { }
                        }

                    } else {
                        history.push("/login/");
                    }
                });
        }
    }, []);

    const handleChangeCategoria = (e, { value }) => {
        setValue("id_categoria_articolo", value);
    }

    const handleChangeTipologia = (e, { value }) => {
        setValue("tipologia_articolo", value);
        if (value === 'composto') {
            setUnitaMisuraDisabilitato(true);
            setValue('unita_misura_articolo', 'pz');
        } else {
            setUnitaMisuraDisabilitato(false);
            setValue('unita_misura_articolo', '');
        }
    }

    const handleChangeComponenti = (e, { value }) => {
        setValue("componenti_articolo", value);
    }

    const handleChangeAllergeni = (e, { value }) => {
        setValue("allergeni_articolo", value);
    }

    const handleImageCompression = async (imageFile) => {
        enqueueSnackbar("Avvio compressione immagine...", { variant: 'info' });

        const originalSizeMB = imageFile.size / 1024 / 1024;

        var options = {
            maxSizeMB: 0.5,
            maxWidthOrHeight: 1920,
            useWebWorker: false,
            maxIteration: 5
        }
        try {
            const compressedFile = await imageCompression(imageFile, options);
            const compressedSizeMB = compressedFile.size / 1024 / 1024;

            const newFile = new File([compressedFile], imageFile.name, { type: compressedFile.type });

            setCompressedImage(newFile);
            setCompressedImageInfo(`Dimensione compressa: ${compressedSizeMB.toFixed(2)} MB`);

            if (previewUrl) URL.revokeObjectURL(previewUrl);
            setPreviewUrl(URL.createObjectURL(newFile));

            setFlagImmagineModificata(true);

            const reductionPercentage = ((originalSizeMB - compressedSizeMB) / originalSizeMB) * 100;
            enqueueSnackbar(`Compressione terminata! Riduzione del ${reductionPercentage.toFixed(2)}%`, { variant: 'success' });

        } catch (error) {
            enqueueSnackbar("Errore durante la compressione", { variant: 'error' });
        }
    }

    const handleChangeImmagine = (e) => {
        setCompressedImageInfo('');
        if (previewUrl) URL.revokeObjectURL(previewUrl);

        if (e.target.files.length === 0) {
            setCompressedImage(null);
            setFlagImmagineModificata(false);
            return;
        }

        if (e.target.files[0].size < 20000000) {
            handleImageCompression(e.target.files[0]);
        } else {
            e.target.value = null;
            alert("L'immagine selezionata è troppo grande. Max 20MB");
        }
    }

    const stampaSezioneComposto = tipologia => {
        if (tipologia === 'composto') {
            return (
                <Fragment>
                    <Form.Field>
                        <label>Componenti disponibili per questo prodotto:</label>
                        <Dropdown fluid multiple selection options={arrayOpzioniComponentiArticoli} value={arrayOpzioniComponentiArticolo} onChange={handleChangeComponenti} />
                    </Form.Field>
                    <Form.Field>
                        <label>Nuovi componenti separati da virgola:</label>
                        <input ref={register} name="componenti_aggiunti_articolo" id="componenti_aggiunti_articolo" placeholder='' type="text" />
                        <Label pointing>Esempio: fiordilatte, cioccolato...</Label>
                    </Form.Field>
                    <Form.Field>
                        <label>N° massimo componenti selezionabili:</label>
                        <input ref={register} name="numero_max_componenti_articolo" id="numero_max_componenti_articolo" placeholder='Numero massimo' type="number" />
                        <Label pointing>Minimo 1, massimo 10</Label>
                    </Form.Field>
                </Fragment>
            )
        }
    }

    const onSubmit = data => {
        setSaving(true);

        if (data.nome_articolo !== '' && data.unita_misura_articolo !== '' && data.prezzo_articolo !== '') {
            enqueueSnackbar("Attendere, salvataggio in corso...", { variant: 'success', autoHideDuration: 2000 });

            const dataToSend = { ...data };
            if (Array.isArray(dataToSend.allergeni_articolo)) dataToSend.allergeni_articolo = JSON.stringify(dataToSend.allergeni_articolo);
            if (Array.isArray(dataToSend.componenti_articolo)) dataToSend.componenti_articolo = JSON.stringify(dataToSend.componenti_articolo);

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(dataToSend)
            };

            fetch('https://ordinasicuro.it/670914_920408/lib/api/crea_articolo/', requestOptions)
                .then(response => response.json())
                .then(dati => {
                    if (dati.esito === "ok" && flagImmagineModificata) {
                        const formDataImmagine = new FormData();
                        formDataImmagine.append('nuova_immagine_articolo', compressedImage);

                        fetch('https://ordinasicuro.it/670914_920408/lib/api/aggiorna_immagine_articolo/' + dati.id_articolo_inserito + '/', {
                            method: 'POST',
                            body: formDataImmagine
                        }).then(response => response.text()).then(resp => {
                            if (resp === "ok") history.goBack();
                            else {
                                setSaving(false);
                                enqueueSnackbar("Errore nel salvataggio immagine", { variant: 'error' });
                            }
                        });
                    } else if (dati.esito === 'ok') {
                        history.goBack();
                    } else {
                        setSaving(false);
                        enqueueSnackbar("Errore nel salvataggio prodotto", { variant: 'error' });
                    }
                });
        } else {
            setSaving(false);
            alert("Compila tutti i campi prima di salvare!");
        }
    }

    return (
        <Fragment>
            <div className="mt6">
                <Modal
                    closeIcon
                    open={openModaleImmagine}
                    onClose={() => setOpenModaleImmagine(false)}
                    onOpen={() => setOpenModaleImmagine(true)}
                >
                    <Header icon='trash' content='Elimina immagine' />
                    <Modal.Content>
                        <p>Vuoi davvero eliminare questa immagine?</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='red' onClick={() => setOpenModaleImmagine(false)}>
                            <Icon name='remove' /> No
                        </Button>
                        <Button color='green' onClick={() => setOpenModaleImmagine(false)} >
                            <Icon name='checkmark' /> Sì
                        </Button>
                    </Modal.Actions>
                </Modal>

                <SezioneBoxed>
                    <div className="w-100">
                        <Button onClick={() => history.goBack()} icon labelPosition='left'>
                            <Icon name='arrow left' />
                            Torna indietro
                        </Button>

                        <h2>Duplica prodotto</h2>
                        <Form onSubmit={handleSubmit(onSubmit)} nome="formDuplicaArticolo" id="formDuplicaArticolo" enctype='multipart/form-data'>
                            <input type="hidden" ref={register} name="id_negozio" id="id_negozio" value={JSON.parse(localStorage.getItem('infoUtente')).id_negozio} />

                            <Form.Field>
                                <label>Immagine prodotto:</label>
                                <input ref={register} type='file' accept="image/*" name='immagine_articolo' id="immagine_articolo" onChange={handleChangeImmagine} />
                                <Label pointing>Max 20MB, compressione automatica</Label>
                                {compressedImageInfo && (<Label pointing color='blue'>{compressedImageInfo}</Label>)}
                                {previewUrl && (<Image src={previewUrl} size='small' className='mt2' />)}
                            </Form.Field>

                            <Form.Field>
                                <label>Nome:</label>
                                <input ref={register} name="nome_articolo" id="nome_articolo" placeholder='Nome del prodotto' maxLength="60" />
                                <Label pointing>Max 60 caratteri</Label>
                            </Form.Field>

                            <Form.Field>
                                <label>Descrizione:</label>
                                <textarea ref={register} name="descrizione_articolo" id="descrizione_articolo" placeholder='Descrizione' maxLength="900" />
                                <Label pointing>Max 900 caratteri</Label>
                            </Form.Field>

                            <Form.Field>
                                <label>Categoria:</label>
                                <Dropdown fluid selection name="id_categoria_articolo" id="id_categoria_articolo" options={arrayOpzioniCategorie} value={idCategoriaArticolo} onChange={handleChangeCategoria} />
                            </Form.Field>

                            <Form.Field>
                                <label>Tipologia:</label>
                                <Dropdown fluid selection name="tipologia_articolo" id="tipologia_articolo" options={[
                                    { key: 'semplice', text: 'Semplice', value: 'semplice' },
                                    { key: 'composto', text: 'Composto', value: 'composto' }
                                ]} value={tipologia} onChange={handleChangeTipologia} />
                            </Form.Field>

                            {stampaSezioneComposto(tipologia)}

                            <Form.Field>
                                <label>Unità di misura:</label>
                                <input disabled={unitaMisuraDisabilitato} ref={register} name="unita_misura_articolo" id="unita_misura_articolo" placeholder='Unità di misura' maxLength="9" />
                                <Label pointing>Max 9 caratteri</Label>
                            </Form.Field>

                            <Form.Field>
                                <label>Allergeni:</label>
                                <Dropdown placeholder='Seleziona allergeni' fluid multiple selection options={allergeni} onChange={handleChangeAllergeni} value={arrayAllergeni} />
                            </Form.Field>

                            <Form.Field>
                                <label>Prezzo:</label>
                                <input ref={register} step="any" name="prezzo_articolo" id="prezzo_articolo" placeholder='Prezzo' type="number" />
                                <Label pointing>Usa "." per i decimali</Label>
                            </Form.Field>

                            <Form.Field>
                                <Button loading={saving} type="submit" color='green'>Salva</Button>
                            </Form.Field>

                        </Form>
                    </div>
                </SezioneBoxed>

            </div>
        </Fragment>
    )
}

export default DuplicaArticolo
